import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import FlagOutlinedIcon from '@material-ui/icons/FlagOutlined'
import React from 'react'

export enum ProductListingIconType {
    ADD = 'ADD',
    BOD = 'BOD',
    FLAGFORREVIEW = 'FLAGFORREVIEW',
}

export enum ProductListingIconStatusType {
    ACTIVE = 'ACTIVE',
    INITIAL = 'INITIAL',
    HOVERED = 'HOVERED',
    DISABLED = 'DISABLED',
    BADGE = 'BADGE',
}

export interface ProductListingIconProps {
    iconType?: ProductListingIconType
    iconSize?: number
    iconColors?: Record<string, string>
    iconStatusType: ProductListingIconStatusType
    [key: string]: any
}

const ProductListingIcon: React.FC<ProductListingIconProps> = ({
    iconType,
    iconSize: iconSizeProp,
    iconStatusType,
    iconColors,
    ...props
}) => {
    let iconClass = 'imgInitial'
    let iconColor = iconColors?.default || '#FFFFFF'
    let iconSize = iconSizeProp
    let iconOpacity = 1

    switch (iconStatusType) {
        case ProductListingIconStatusType.ACTIVE:
            iconColor = iconColors?.active || '#FFFFFF'
            iconSize = 24
            iconClass = 'imgActive'
            break
        case ProductListingIconStatusType.INITIAL:
            iconColor = iconColors?.initial || '#A78966'
            iconSize = 24
            iconClass = 'imgInitial'
            break
        case ProductListingIconStatusType.HOVERED:
            iconClass = 'imgHovered'
            iconColor = iconColors?.hovered || '#E69C24'
            iconSize = 24
            break
        case ProductListingIconStatusType.DISABLED:
            iconClass = 'imgDisabled'
            iconColor = iconColors?.disabled || '#A78966'
            iconSize = 24
            iconOpacity = 0.5
            break
        case ProductListingIconStatusType.BADGE:
            iconClass = 'imgBadge'
        default:
            iconColor = iconColors?.default || '#FFFFFF'
            iconSize = 24
            break
    }
    switch (iconType) {
        case ProductListingIconType.ADD:
            return (
                <AddCircleOutlineIcon
                    {...props}
                    style={{
                        color: iconColor,
                        fontSize: iconSizeProp ?? iconSize,
                        ...props.style,
                    }}
                    className={iconClass}
                    data-testid="addAsProduct"
                    opacity={iconOpacity}
                    fontWeight={'normal'}
                />
            )
        case ProductListingIconType.BOD:
            // TODO: replace with MUI icon when versoin is updated
            const viewBoxScale =
                iconStatusType === ProductListingIconStatusType.BADGE
                    ? 1.2
                    : 1.05
            return (
                <svg
                    {...props}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox={`0 0 30 30`}
                    height={iconSizeProp ?? iconSize}
                    width={iconSizeProp ?? iconSize}
                    fill={iconColor}
                    className={iconClass}
                    data-testid="addAsBOD"
                    opacity={iconOpacity}
                >
                    <g>
                        <path d="M15.375 21.875V16.75H20.5V14.875H15.375V9.5H13.5V14.875H8.125V16.75H13.5V21.875H15.375Z" />
                        <path d="M26.625 14.375C26.125 14.5 25.75 14.625 25.25 14.625C25.125 14.625 25 14.625 24.875 14.625C24.875 15 24.875 15.25 24.875 15.625C24.875 18.5 23.875 21 21.75 23.125C19.75 25.125 17.25 26.25 14.25 26.25C11.375 26.25 8.875 25.25 6.75 23.125C4.75 21.125 3.625 18.625 3.625 15.625C3.625 12.625 4.625 10.125 6.75 8.125C8.75 6.125 11.25 5 14.25 5C15.125 5 15.875 5.125 16.625 5.25C16.75 4.625 17.125 4 17.5 3.625C16.5 3.375 15.375 3.125 14.25 3.125C12.5 3.125 10.875 3.5 9.375 4.125C8 4.875 6.625 5.75 5.5 6.875C4.375 8 3.5 9.375 2.875 10.875C2.25 12.375 1.875 14 1.875 15.75C1.875 17.5 2.25 19.125 2.875 20.625C3.5 22.125 4.375 23.5 5.5 24.625C6.625 25.75 8 26.625 9.5 27.25C11 27.875 12.625 28.25 14.375 28.25C16.125 28.25 17.75 27.875 19.25 27.25C20.75 26.625 22.125 25.75 23.25 24.625C24.375 23.5 25.25 22.125 25.875 20.625C26.5 19.125 26.875 17.5 26.875 15.75C26.75 15.25 26.75 14.875 26.625 14.375Z" />
                        <path d="M17.875 13.75L18.875 9.375L15.375 6.375L20 6L21.75 1.875L23.5 6L28.125 6.375L24.625 9.375L25.625 13.75L21.75 11.375L17.875 13.75Z" />
                    </g>
                </svg>
            )
        case ProductListingIconType.FLAGFORREVIEW:
            return (
                <FlagOutlinedIcon
                    {...props}
                    style={{
                        color: iconColor,
                        fontSize: iconSizeProp ?? iconSize,
                        ...props.style,
                    }}
                    className={iconClass}
                    data-testid="flagForReview"
                    opacity={iconOpacity}
                />
            )
        default:
            return <></>
    }
}

export default ProductListingIcon
